import { FiPlus } from "react-icons/fi";

export interface GhostAddRowProps {
	/**
	 * Total grid column count: leading sticky # cell + N body columns +
	 * trailing button cell. Used as the colSpan so the ghost row spans
	 * the full table width.
	 */
	colSpan: number;
	onAdd: () => void;
	label?: string;
	"data-testid"?: string;
}

/**
 * Trailing "+ Add row" tr used inside SpreadsheetGrid bodies. Mirrors the
 * visual treatment of GhostAddColumn so add-row and add-column read as a
 * matched pair.
 */
export const GhostAddRow: React.FC<GhostAddRowProps> = ({
	colSpan,
	onAdd,
	label = "Add row",
	"data-testid": dataTestId = "ghost-add-row",
}) => {
	return (
		<tr role="row" data-testid={dataTestId}>
			<td
				role="gridcell"
				colSpan={colSpan}
				className="border border-dashed border-[#D0D5DD] bg-[#F9FAFB] p-0"
			>
				<button
					type="button"
					onClick={onAdd}
					className="flex w-full items-center justify-center gap-1 py-2 text-xs font-medium text-tertiary-600 hover:bg-gray-100 hover:text-primary-500"
				>
					<FiPlus size={14} />
					{label}
				</button>
			</td>
		</tr>
	);
};

export default GhostAddRow;
